<template>
  <div v-title data-title="订单详情" class="mobile" style="background-color:#f4f4f4;">
    <scroller>
      <div class="order-banner">
        <img src="../../assets/img/order-banner.png" />
        <label class="orderstate">
          <span>{{(formset.OrderStateAndCustomerState.replace(/已确认/, "待发货")).split(' ')[0]}}</span>
          <span v-if="LoginType==4&&formset.OrderType==2">（分销订单）</span>
        </label>
      </div>
      <section class="container">
        <div class="user-info" v-if="formset.DeliveryAddress!=null">
          <p class="name">
            {{formset.DeliveryAddress.ReceiverName}}
            <span>{{formset.DeliveryAddress.ReceiverPhone}}</span>
          </p>
          <p
            class="address"
          >{{formset.DeliveryAddress.Province}}{{formset.DeliveryAddress.City}}{{formset.DeliveryAddress.Address}}</p>
        </div>
        <div class="neworder-list" style="margin-bottom:10px">
          <div @click="product_ssDetail()" class="flex">
            <div class="pro-img">
              <a href="javascript:void(0)">
                <img
                  v-lazy="formset.ProductImgUrl"
                  class="lazy-img-fadein"
                  :key="formset.ProductImgUrl"
                />
              </a>
            </div>
            <div class="pro-title">
              <p class="name">{{formset.ProductName}}</p>
              <p class="info">{{formset.ComboName}}</p>
              <p class="tag">
                <!-- <span v-for="(tag,$index) in formset.ComboTags" :Key="$index"
                :style="$index==0?'display:none':''">{{tag}}</span>-->
              </p>
            </div>
            <div class="pro-price">
              <p v-if="LoginType==5">{{(formset.TotalSalePrice)|currency('￥',2)}}</p>
              <p v-if="LoginType==4">{{(formset.TotalSalePrice-formset.Commission)|currency('￥',2)}}</p>
              <p class="newnum">*{{formset.TotalCount}}</p>
            </div>
          </div>
        </div>

        <!-- <div class="weui-form-preview">
          <div class="weui-form-preview__item" v-if="formset.ProductType!=6">
            <label
              v-if="formset.ComboPriceType==1"
              class="weui-form-preview__label"
            >使用日期：{{formset.StartDate| date('yyyy-MM-dd')}}至{{formset.EndDate| date('yyyy-MM-dd')}}</label>
            <label
              v-if="formset.ComboPriceType==2"
              class="weui-form-preview__label"
            >出发日期：{{formset.StartDate| date('yyyy-MM-dd')}}</label>
            <label
              v-if="formset.ComboPriceType==2"
              class="weui-form-preview__label"
            >天数：{{formset.Days}}天</label>
          </div>
          <div v-if="formset.OrderEnableRefund==1" class="weui-form-preview__item">
            <label class="weui-form-preview__label">退款截止时间：{{formset.RefundDate}}</label>
          </div>
        </div>-->

        <div class="order-product">
          <div class="order-product-t">产品信息</div>
          <ul>
            <li v-if="formset.ProductType==-1&&formset.ComboPriceType==1">
              使用日期：
              <span
                class="fr"
              >{{formset.StartDate| date('yyyy-MM-dd')}}至{{formset.EndDate| date('yyyy-MM-dd')}}</span>
            </li>
            <li v-if="formset.ProductType==-1&&formset.ComboPriceType==2">
              出发日期：
              <span class="fr">{{formset.StartDate| date('yyyy-MM-dd')}}</span>
            </li>
            <li v-if="formset.ProductType==-1&&formset.ComboPriceType==2">
              天数：
              <span class="fr">{{formset.Days}}天</span>
            </li>
            <li>
              退款截止时间：
              <span
                class="fr"
              >{{formset.ComboTags[1]=="可退款"? formset.RefundDate:formset.ComboTags[1]}}</span>
            </li>
          </ul>
        </div>

        <div class="order-details">
          <div class="order-details-t">订单信息</div>
          <ul>
            <li>
              订单编号
                <span class="fr">{{formset.OrderNumber}}</span>
            </li>
            <li>
              付款方式
              <span class="fr">微信支付</span>
            </li>
            <li>
              订单总价
              <span
                v-if="LoginType==4"
                class="fr"
              >{{(formset.TotalSalePrice-formset.Commission)|currency('￥',2)}}</span>
              <span v-if="LoginType==5" class="fr">{{(formset.TotalSalePrice)|currency('￥',2)}}</span>
            </li>
            <!-- <li>
              分销商省
              <span class="fr">￥{{formset.Commission}}</span>
            </li>-->
            <li>
              实付金额
              <span
                v-if="LoginType==4"
                class="fr"
              >{{(formset.TotalSalePrice-formset.Commission)|currency('￥',2)}}</span>
              <span v-if="LoginType==5" class="fr">{{(formset.TotalSalePrice)|currency('￥',2)}}</span>
            </li>
          </ul>
          <div class="order-details-time">
            <span>订单时间：{{formset.CreateTime| date('yyyy-MM-dd hh:mm')}}</span>
          </div>
        </div>

        <!-- 已付款或已确认订单显示核销券码信息 -->
        <!-- <div v-if="formset.OrderState==40" class="order-product">
          <div class="order-product-t">核销券码</div>
          <wv-group>
            <wv-cell
              style="font-size:14px"
              @click="rollcodedetail(dm.Guid)"
              v-for="(dm,$index) in formset.RollCodes"
              :key="$index"
              :title="(dm.CodeType)+dm.ShowNumber"
              :value="dm.TollCode+' '+(dm.ChargeOffState)"
              is-link
            ></wv-cell>
          </wv-group>
        </div> -->

        <div class="reserve-info">
          <div class="title">收货地址</div>
          <ul>
            <li>
              姓名：
              <span class="fr">{{formset.DeliveryAddress.ReceiverName}}</span>
            </li>
            <li>
              手机号码：
              <span class="fr">{{formset.DeliveryAddress.ReceiverPhone}}</span>
            </li>
            <li>
              收件人地址：
              <span class="fr">{{formset.DeliveryAddress.Province+formset.DeliveryAddress.City+formset.DeliveryAddress.Address}}</span>
            </li>
          </ul>
        </div>
      </section>
      <br />
      <br />

      <div class="order-detail-footer">
        <!-- <button
          @click="pay()"
          v-if="formset.OrderState==20&&formset.OrderType==1"
          class="btn-out-active"
        >付款</button>
        <button
          @click="applyrefound()"
          v-if="formset.OrderType==1&&formset.OrderEnableRefund==1"
          class="btn-outline"
        >申请退款</button>
        <button
          @click="refound()"
          v-if="formset.OrderType==1&&formset.ProductType==-1&&formset.OrderEnableRefund==1"
          class="btn-outline"
        >申请退款</button> -->
        <button
          @click="urgentNotice()"
          v-if="formset.OrderState==40"
          class="btn-outline"
        >提醒发货</button>
        <button
          @click="viewLogistics()"
          v-if="(formset.OrderState==60||formset.OrderState==70)"
          class="btn-outline"
        >查看物流</button>
        <!-- <button
          @click="confirmReceipt()"
          v-if="formset.OrderType==1&&formset.OrderState==60"
          class="btn-outline"
        >确认收货</button> -->
      </div>
    </scroller>
  </div>
</template>

<script>
import { Toast } from "we-vue";

export default {
  name: "orderdetaildisview",
  data: function() {
    return {
      LoginType: -1,
      formset: {},
      orderguid: "",
      fromshorturl: "",
      paymodel: null,
      timer: null,
      type: null, //type=pay 初始化页面时直接引发支付
      borwser: this.GLOBAL.borwser
    };
  },
  created: function() {
    this.fromshorturl = this.$route.query.fromshorturl;
    this.InitProductpreorder();
    var url = window.location.href;
    this.type = this.GetRequest(url)["type"];
    this.orderguid = this.$route.query.OrderGuid;
  },
  mounted: function() {
    var url = window.location.href;
    var code = this.GetRequest(url)["code"];
    if (code != undefined) {
      //绑定微信
      console.info(code);
      this.BindWechat(code);
    }
  },
  methods: {
    urgentNotice: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tborder/urgentnotice", {
          params: {
            orderGuid: this.orderguid
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            Toast.success("提醒发货成功");
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    confirmReceipt: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tborder/confirmreceipt", {
          params: {
            orderGuid: this.orderguid
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            Toast.success("确认收货成功");
            this.InitProductpreorder();
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    viewLogistics: function() {
      //如果是多条物流，先跳转到物流列表页
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tblogistics/getcount", {
          params: { orderGuid: this.orderguid }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              if (rep.Data > 1) {
                this.$router.push({
                  path: "/page/logisticlist",
                  query: {
                    orderguid: this.orderguid
                  }
                });
              } else {
                this.$router.push({
                  path: "/page/viewlogistics",
                  query: {
                    orderguid: this.orderguid
                  }
                });
              }
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    applyrefound: function() {
      this.$router.push({
        path: "/page/applyrefound",
        query: {
          orderguid: this.orderguid
        }
      });
    },
    BindWechat: function(code) {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/bindwechat", {
          params: {
            code: code
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            //绑定成功
            window.location.href =
              this.GLOBAL.WEB_URL +
              "/#/page/orderdetail?OrderGuid=" +
              this.orderguid +
              "&type=pay";
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    pay: function() {
      //判断浏览器
      if (this.borwser != "wechat") {
        Toast.fail("请在微信浏览器中进行支付");
        return;
      }
      if (this.paymodel == null) {
        //向微信下单
        this.$http
          .get(this.GLOBAL.BASE_URL + "api/pay/jsapipay", {
            params: {
              orderGuid: this.$route.query.OrderGuid
            }
          })
          .then(function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.paymodel = rep.Data;
              this.startPay();
            } else {
              if (rep.Message == "请先授权微信公众号") {
                window.location.href =
                  "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
                  this.GLOBAL.appid +
                  "&redirect_uri=" +
                  this.GLOBAL.redirect_uri +
                  "%23%2Fpage%2Forderdetail%3FOrderGuid%3D" +
                  this.orderguid +
                  "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
              } else {
                Toast.fail(rep.Message);
              }
            }
          });
      } else {
        this.startPay();
      }
    },

    startPay: function() {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
        }
      } else {
        this.onBridgeReady();
      }
    },

    onBridgeReady: function() {
      let that = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: this.paymodel.appId, //公众号名称，由商户传入
          timeStamp: this.paymodel.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: this.paymodel.nonceStr, //随机串
          package: this.paymodel.package,
          signType: this.paymodel.signType, //微信签名方式：
          paySign: this.paymodel.paySign //微信签名
        },
        function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            that.$store.commit("showLoading");
            //alert("OK");
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            that.$http
              .get(that.GLOBAL.BASE_URL + "api/tborder/checkorderpayresult", {
                params: {
                  orderGuid: that.$route.query.OrderGuid,
                  out_trade_no: that.paymodel.out_trade_no
                }
              })
              .then(function(d) {
                var rep = JSON.parse(d.bodyText);
                that.$store.commit("hideLoading");
                if (rep.Success) {
                  if (rep.Data) {
                    Toast.success("支付成功");
                    that.$router.push("/app/order");
                  }
                } else {
                  Toast.fail(rep.Message);
                }
              });
          }
        }
      );
    },

    rollcodedetail: function(guid) {
      this.$router.push({
        path: "/page/rollcodedetail",
        query: {
          guid: guid
        }
      });
    },
    InitProductpreorder: function() {
      var url = "";
      if (this.fromshorturl == "1") {
        url = "api/tborder/getfromshorturl";
      } else {
        url = "api/tborder/get";
      }
      this.$http
        .get(this.GLOBAL.BASE_URL + url, {
          params: {
            OrderGuid: this.$route.query.OrderGuid
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.formset = rep.Data;
            if (this.formset.ProductName.length >= 27) {
              this.formset.ProductName =
                this.formset.ProductName.substring(0, 27) + "...";
            }
            this.LoginType = this.formset.LoginType;
            if (this.type == "pay" && this.formset.OrderState == 20) {
              this.type = "";
              this.pay();
            }
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    refound: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tborder/applyrefound", {
          params: {
            OrderGuid: this.$route.query.OrderGuid
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            Toast.success("申请退款成功");
            this.$router.push("/app/order");
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    product_ssDetail: function() {
      this.$router.push({
        path: "/page/product_ssdetail",
        query: {
          id: this.$route.query.OrderGuid
        }
      });
    }
  }
};
</script>

<style>
.weui-spaces {
  height: 10px;
  background-color: #efeff4;
}

.orderstate {
  top: 50px;
  left: 20px;
  position: absolute;
  color: #fefffd;
  font-size: 1.3rem;
}

.weui-cell__bd p {
  font-size: 14px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/order/orderdetaildisview.vue